var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      key: _vm.item._uid,
      staticClass: "link text-white text-nav leading-loose",
      attrs: { to: _vm.item.link },
      on: { click: _vm.handleClick },
    },
    [_vm._v("\n    " + _vm._s(_vm.item.label) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }